import React from 'react'
import css from './styles.module.scss'
import Text from 'components/typo/Text'
import Typo from 'components/typo/Typo'
import Image from 'components/shared/Image'
import classNames from 'classnames/bind'
import Button from '../Button'

const BenefitCard = ({
  title,
  description,
  icon,
  alignCenter = true,
  shadow = false,
  links,
  smallTitle = true,
  isColumn = false,
}) => {
  const cx = classNames.bind(css)
  return (
    <div
      className={cx(css.wrapper, {
        [css.alignCenter]: alignCenter,
        [css.boxShadow]: shadow,
        [css.column]: isColumn,
      })}
    >
      <Image
        className={css.image}
        media={{ width: 32, height: 32 }}
        fluid
        {...icon}
        alt=""
      />
      <div className={css.column}>
        <Typo
          className={cx({
            [css.smallTitle]: smallTitle,
            [css.title]: !smallTitle,
          })}
        >
          {title}
        </Typo>
        <Text className={css.description}>{description}</Text>
      </div>
      {links && (
        <div className={css.linksRow}>
          {links.map((link) => (
            <Button
              theme="link"
              className={css.linkBtn}
              href={link.href}
              as={link.as}
            >
              <span>{link.text}</span>
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}

export default BenefitCard
